import React from "react";
import { ReactController } from "../react_controller";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { BlockedDatesGrid } from "../../components/grids/BlockedDatesGrid";

const queryClient = new QueryClient();

export class BlockedDatesGridController extends ReactController {
  connect() {
    this.root.render(
      <QueryClientProvider client={queryClient}>
        <BlockedDatesGrid {...this.propsValue} />
      </QueryClientProvider>
    );
  }
}
